import { Pipe, PipeTransform } from '@angular/core';
import { MemberDto } from '@careapp-group/ng-sdk-v2-new';

@Pipe({
  name: 'memberExternalId',
})
export class MemberExternalIdPipe implements PipeTransform {
  transform(value: MemberDto) {
    if (!value) {
      return;
    }
    if (!value.permissions || !value.permissions.length) {
      return;
    }

    return value.permissions.map((permission) => permission.externalId).join(', ');
  }
}
